/**
 * EntitiesMode - Phase-based entity tree view
 * Shows entities relevant to current journey phase with validation controls
 */

import { EntityTree } from '@/components/tree'

interface EntitiesModeProps {
  context: WorkspaceContext
}

interface WorkspaceContext {
  mode: string
  phaseId: string
  journeyMode: string
}

export function EntitiesMode({ context }: EntitiesModeProps) {
  return (
    <div className="h-full bg-warm-50">
      <EntityTree
        defaultMode="structured"
        showModeToggle
        showPhaseIndicator
        showValidationActions
      />
    </div>
  )
}
